import * as React from 'react';
export const isReactFragment = (node) => {
    if (!node)
        return false;
    if (node === null || node === void 0 ? void 0 : node.type) {
        return (node === null || node === void 0 ? void 0 : node.type) === React.Fragment;
    }
    return node === React.Fragment;
};
//# sourceMappingURL=isReactFragment.js.map